import { AbstractReportPmsApiService } from '../abstract-report.service';
import { FrontDeskCancellationReport } from '../../../models/reports/front-desk/cancellation-report.model';

/**
 * @class FrontDeskCancellationReportPmsApiService
 * @extends {AbstractReportPmsApiService<FrontDeskCancellationReport>}
 */
export class FrontDeskCancellationReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/front-desk/cancellation';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {FrontDeskCancellationReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new FrontDeskCancellationReport(attributes);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/front-desk/cancellation-report.service.js